import list from './list';
import request from './request';

const multiFactorAuthentication = {
  list,
  request,
};

export default multiFactorAuthentication;
